import React from "react";
import "./SortTabs.css";

const OPTIONS = [
  { id: "recommended", label: "מומלץ" },
  { id: "cheapest", label: "הכי זול" },
  { id: "fastest", label: "הכי מהיר" },
];

export default function SortTabs({ value, onChange }) {
  return (
    <div className="fe2-sort" role="group" aria-label="מיון">
      {OPTIONS.map((opt) => (
        <button
          key={opt.id}
          type="button"
          className={
            value === opt.id
              ? "fe2-sort__tab fe2-sort__tab--active"
              : "fe2-sort__tab"
          }
          onClick={() => onChange?.(opt.id)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
